// extracted by mini-css-extract-plugin
export default {"logoBox":"_1G16-cM2","content":"_13iLdco9"};